
    import NotaService from   "@/service/v1/sigap/NotaService"   
    import DisciplinaService from   "@/service/v1/sigap/DisciplinaService"   
	import CadastroInline from '@/components/aplicacao/CadastroInline.vue';    
    import Multiselect from '@vueform/multiselect'
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import ListaCampoForm from '@/components/aplicacao/ListaCampoForm.vue'; 
    import { Options , Vue  } from "vue-class-component";   
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import   SiteUtils   from '@/assets/ts/aplicacao/site';  
	import $ from "jquery"   
    import {  Prop  , Watch } from 'vue-property-decorator';   
	  
    @Options({
        name: "NotaCadastro",
        components: {  CadastroInline  , Multiselect, ListaCampoForm, BotaoSalvar   },  
        emits: [  'nota-matricula-criada'],  
    }) 
    export default class NotaCadastro extends Vue {
          
        @Prop( ) readonly modal!: any  
        @Prop( ) readonly perfis!: any  
        @Prop( ) readonly matricula!: any

        public disciplinaService = new DisciplinaService();  
        public notaService = new NotaService();   

        public nota: any = null ; 
        public disciplinas: any = null ; 
        public disciplina: any = null ; 
        public tipo_id: any = null ;  
         
          
        public tiposNota: any  =  null ;  
        public titulo = 'Cadastro';
        public processando = false;   
         
        async created()  {   
            this.buscaTiposProva(); 
            this.buscaDisciplinas(); 
        }
        
        public buscaDisciplinas( ) {
            this.processando = true ;  
            this.disciplinaService.getAll( `skip=0&take=1000&turmaId=${this.matricula.turmaId}`) 
            .then(response => {    
                this.disciplinas =   response.data;   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            });  
        }
        
        get disciplinas_select(){
            if( this.disciplinas){ 
                return this.disciplinas.map((item) => { return { value:  item , label: item.descricao } });   
            }
            return null;
        }

        public buscaTiposProva( ) {
            this.processando = true ;  
            this.notaService.getTipo( ) 
            .then(response => {   
                this.tiposNota =  JSON.parse(JSON.stringify( response ));   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            });  
        }
  
        get avaliacoes_select(){ 
            if(this.tiposNota && this.disciplina){
                let filtrados = this.tiposNota.filter( tipo => {  
                    if( parseInt(this.disciplina?.quantiadadeAvaliacao) >= parseInt(tipo.id )){ return true; } 
                    if( parseInt(this.disciplina?.quantidadeTrabalho ) + 5 >= parseInt(tipo.id )){  if(parseInt(tipo.id ) > 5 ){ return true;  }	} 
                    if( parseInt(tipo.id ) >=16 ){ return true; } 
                });  
                
                return filtrados.map((item) => { return { value:  item.id , label: item.nome } });   
            }
            return null;
        }
        
        get notas_select(){ 
            return [ { value:  10 , label: 'Apto' } , { value:  0 , label: 'Inapto' } ];    
        } 
       
        get hasPermissao(): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin,  PerfilConfig.ChefeSTE,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
   
        public sucesso(){  
            this.$emit("nota-matricula-criada", null);     
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }
         
        public getdados(){   
            let dados:any = {};  
            dados.matriculaId = this.matricula.id;  
            dados.disciplinaId = this.disciplina.id;  
            dados.notaValor = this.nota;  
            dados.tipo = this.tipo_id;  
            dados.status = 1;  
            return dados;
        }
 
        public salvar(){
            if( this.processando  ||  !this.hasPermissao ){
                return;
            }
            this.processando = true ;  
            let dados = this.getdados() ;  
            setTimeout(() => {  
                this.notaService.cadastrar( dados )
                .then(response => { 
                    SiteUtils.toastSucesso('Cadastrado com sucesso! ' ,  response.message  ); 
                    this.sucesso();  
                    this.processando = false ;  
                }) 
                .catch(error => {
                    this.processando = false ;
                    SiteUtils.toastErro('Error! ' ,  error.data.message  );
                });  
            }, 100); 
        }   

    } 
